import 'devbridge-autocomplete'

let searchInput = $('.search-input');

// Search box focus behaviour
$(searchInput).focusin(function() {
    $(this).closest('.search-form').addClass('focused');

    // Hide meta nav labels to have more space for the expanded search box
    if ($(this).hasClass('search-input-header'))
        $('header .hide-on-search-focus').addClass('d-none');

    // Scroll to top
    if ($(this).hasClass('search-input-mobile')) {
        $('html, body').animate({
            scrollTop: $(this).offset().top - 15
        }, 300);
    }
}).focusout(function() {
    setTimeout(function() {
        $('.search-form').removeClass('focused');
        $('header .hide-on-search-focus').removeClass('d-none');

        // Clear search input for various reasons
        // * users most probably won't continue their previous search but rather start a new search
        // * suggestion container would be still there with wrong width on the next focusin
        $('.search-input-header').val('');
    }, 200);
});

// Autocomplete configuration
$(searchInput).autocomplete({

    // Defer AJAX calls by 200ms to reduce HTTP requests
    // UX improvement if the keyword changes very fast (reduce suggestion box flickering)
    deferRequestBy: 200,

    serviceUrl: $(searchInput).data('autocomplete-source'),
    paramName: 'term',
    dataType: 'json',

    transformResult: function(response) {
        let completions = $.map(response.completions, function(completion) {
            return { value: completion, data: { type: 'completion' } };
        });
        let nodes = $.map(response.suggestions, function(suggestion) {
            return { value: suggestion.payload.label, data: suggestion.payload };
        });

        return { suggestions: completions.concat(nodes) };
    },

    // Format suggestion results by type and given data properties
    formatResult: function (suggestion, currentValue) {

        let utils = (function () {
            return {
                escapeRegExChars: function (value) {
                    return value.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
                },
                createNode: function (containerClass) {
                    let div = document.createElement('div');
                    div.className = containerClass;
                    div.style.position = 'absolute';
                    div.style.display = 'none';
                    return div;
                }
            };
        }());

        let pattern = '(' + utils.escapeRegExChars(currentValue) + ')';

        let label = '';
        if (!currentValue) {
            label = suggestion.value;
        } else {
            label = suggestion.value
                .replace(new RegExp(pattern, 'gi'), '<strong>$1<\/strong>')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/&lt;(\/?strong)&gt;/g, '<$1>');
        }

        if (suggestion.data.type === 'node') {
            return suggestion.data.snippet.replace(/<span>.+<\/span>/, '<span>' + label + '</span>');
        } else {
            return '<div class="suggest-completion" title="' + suggestion.value + '"><i class="fa-fw far fa-search" data-fa-transform="shrink-3"></i> ' + label + '</div>';
        }
    },

    // Autoselect first suggestion and type the completions ahead
    autoSelectFirst: true,
    onHint: function (firstSuggestionValue) {
        $(':focus').prev('input.search-input-typeahead').val(firstSuggestionValue);
    },

    // Open suggested document node on select - if the href property is given
    onSelect: function (suggestion) {
        if (suggestion.data.snippet) {
            let href = suggestion.data.snippet.match(/href="([^"]*)/)[1];

            // TODO: valid uri check disabled - we need to support relative urls
            //if (isValidUri(href))
            if (href)
              window.location.href = href;
        } else {
            $(this).closest('.search-form').submit();
        }
    }
});

function isValidUri(uri) {
    return /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(uri);
}